import { useSortable } from '@dnd-kit/sortable';
import type { CSSProperties } from 'react';

import {
  // useSwimlaneRootProps,
  useSwimlaneState,
} from '@/components/ui/swimlane/context';
import type { TCardId } from '@/components/ui/swimlane/types';
import { SORTABLE_TYPES } from '../../constants';
import { CardDropIndicator, useIsCardDragging } from '../../dnd';

import { CardRenderer } from './CardRenderer';

const draggingStyle: CSSProperties = { opacity: 0.3 };

export function SortableCard({ cardId, ...rest }: { cardId: TCardId }) {
  // const { readOnly } = useSwimlaneRootProps();
  const { setNodeRef, attributes, listeners, isOver } = useSortable({
    id: cardId,
    data: {
      cardId,
      type: SORTABLE_TYPES.Card,
      accepts: [SORTABLE_TYPES.Card],
    },
    // Temporarily disable card DnD (plan for future re-enablement)
    // disabled: readOnly,
    disabled: true,
  });
  const isDragging = useIsCardDragging(cardId);
  const { onCardMount, onCardUnmount } = useSwimlaneState();

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        style={isDragging ? draggingStyle : undefined}
      >
        <CardRenderer cardId={cardId} {...{ ...rest, onCardMount, onCardUnmount }} />
      </div>
      <CardDropIndicator cardId={cardId} isOver={isOver} />
    </>
  );
}
